(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["far-business-details"] && !Shopify.designMode) return;
  try {
    (function(){
  var euAndUk=['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','GB'];
  function update(panel){
    var country=panel.querySelector('#far-business-country').value;
    var id=panel.querySelector('#far-business-tax-id');
    var label=panel.querySelector('[data-far-tax-label]');
    id.required=country!=='DE';
    label.textContent=country==='DE'?panel.dataset.optionalLabel:(euAndUk.includes(country)?panel.dataset.vatLabel:panel.dataset.taxLabel);
  }
  function validate(){
    var panel=document.querySelector('[data-far-business]');
    if(!panel)return true;
    update(panel);
    var fields=panel.querySelectorAll('input,select');
    for(var field of fields){
      if(field.tagName==='INPUT')field.value=field.value.trim();
      if(!field.reportValidity())return false;
    }
    return true;
  }
  document.querySelectorAll('[data-far-business]').forEach(update);
  document.addEventListener('change',function(event){
    if(event.target.id==='far-business-country')update(event.target.closest('[data-far-business]'));
  });
  document.addEventListener('click',function(event){
    var button=event.target.closest('button[name="checkout"][form="cart"]');
    if(button&&!validate()){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('submit',function(event){
    if(event.target.id==='cart'&&event.submitter&&event.submitter.name==='checkout'&&!validate()){
      event.preventDefault();event.stopImmediatePropagation();
    }
  },true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["far-playtime"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-far-licence]').forEach(function(root){
  root.classList.add('is-enhanced');
  var select=root.querySelector('.far-licence__variant');
  var headsetButtons=Array.from(root.querySelectorAll('[data-far-headsets]'));
  var durationButtons=Array.from(root.querySelectorAll('[data-far-duration]'));
  var headset='4 Headsets',duration='30 Days';
  var selected=select.options[select.selectedIndex];
  if(selected){headset=selected.dataset.headsets||headset;duration=selected.dataset.duration||duration;}
  function update(){
    headsetButtons.forEach(function(button){var active=button.dataset.farHeadsets===headset;button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));});
    durationButtons.forEach(function(button){var active=button.dataset.farDuration===duration;button.classList.toggle('is-active',active);button.setAttribute('aria-pressed',String(active));});
    Array.from(select.options).forEach(function(option){if(option.dataset.headsets===headset){var target=root.querySelector('[data-far-price="'+option.dataset.duration+'"]');if(target)target.textContent=option.dataset.price;}});
    var match=Array.from(select.options).find(function(option){return option.dataset.headsets===headset&&option.dataset.duration===duration;});
    if(match){select.value=match.value;root.querySelector('[data-far-summary]').textContent=duration+' · '+headset.toLowerCase();root.querySelector('[data-far-total]').textContent=match.dataset.price;root.querySelector('[data-far-submit]').disabled=match.dataset.available!=='true';root.querySelector('[data-far-submit]').textContent=match.dataset.available==='true'?'Add to cart':'Unavailable';}
  }
  headsetButtons.forEach(function(button){button.addEventListener('click',function(){headset=button.dataset.farHeadsets;update();});});
  durationButtons.forEach(function(button){button.addEventListener('click',function(){duration=button.dataset.farDuration;update();});});
  select.addEventListener('change',function(){var item=select.options[select.selectedIndex];headset=item.dataset.headsets;duration=item.dataset.duration;update();});
  update();
});
  } catch(e) { console.error(e); }
})();

})();
